import { post } from '@/lib/request/index';
import { order } from '../apiConstants';
import api from '@/api';
import { PAYMENT_QUERY_CALLBACK } from '@/const/paymentProcess';
import retry from '@/utils/retry';

// 获取获取订单列表的数据
export const getOrderConfirmApi = function (param) {
  return post(order.ORDER_CONFIRM, { param });
};

// 获取获取订单列表的数据
export const getOrderListApi = function (param) {
  return post(order.ORDER_LIST, { param });
};

// 获取订单状态
export function getOrderStatus({ orderId }) {
  return post(order.ORDER_DETAIL, { param: { orderIds: orderId } });
}

// 欠款单支付
export function debtRepay({ orderId, debtId, payChannel }) {
  return post(order.DEBT_REPAY, { param: { orderId, debtId, payChannel } });
}

// 欠款单支付失败
export function debtRepayFail({ orderId, debtId }) {
  return post(order.DEBT_REPAY_FAIL, { param: { orderId, debtId } });
}

// http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=659142082
export async function getDebtRepay({ orderId, debtId, payChannel }) {
  try {
    let res = await api.debtRepay({ orderId, debtId, payChannel });
    let { transId } = res;

    let queryResult = await api.pollingPayStatusV2(
      { transId },
      { times: 100, timeout: 30 * 1000 },
      PAYMENT_QUERY_CALLBACK.BUSINESS_LEVEL.isCheck
    );

    if (PAYMENT_QUERY_CALLBACK.BUSINESS_LEVEL.isSuccess(queryResult)) {
      return {
        success: true,
        errmsg: 'ok',
      };
    } else {
      let r = await api.debtRepayFail({ orderId, debtId });
      return {
        success: false,
        errmsg: r?.errmsg || res?.errmsg,
      };
    }
  } catch (err) {
    return {
      success: false,
      errmsg: err?.errmsg,
    };
  }
}

// 创建B2C订单
export function apiOrderCreate(param) {
  return post(order.ORDER_CREATE, { param });
}

// 获取订单详情
export function getOrderDetail(param) {
  return post(order.ORDER_DETAIL, { param });
}

// 查询契约单信息
export function getContractOrderInfo({ contractID }) {
  return post(order.ORDER_CONTRACT_INFO, { param: { contractID } });
}

// 轮询契约单信息
export function pollingContractOrderInfo(
  { contractID },
  { times, timeout },
  isSuccess
) {
  const _pollingPayStatus = retry(
    getContractOrderInfo,
    { times, timeout },
    isSuccess
  );
  return _pollingPayStatus({ contractID });
}
